import PropTypes from 'prop-types';
import { truncate } from 'lodash';
import { Typography } from '@mui/material';

import { formatDate } from 'helper/DateLib';
import { useBreakpointFlags } from 'hooks/useBreakpointFlags';
import { TitleTooltip } from 'components/simple/TitleTooltip';

const LABEL_WIDTH = 150;
const LABEL_HEIGHT = 25;

export const LineChartCustomLabel = ({ viewBox, keyEvent = null }) => {
  const { getResponsiveValueForCurrent } = useBreakpointFlags();
  const labelLength = getResponsiveValueForCurrent({
    xs: 15,
    sm: 25,
    md: 20,
    lg: 20,
    xl: 20,
    xxl: 20,
  });

  if (!keyEvent) {
    return null;
  }

  return (
    <g>
      <foreignObject
        style={{ overflow: 'visible' }}
        x={viewBox.x - LABEL_WIDTH / 2}
        y={viewBox.y - LABEL_HEIGHT}
        width={LABEL_WIDTH}
        height={LABEL_HEIGHT}
      >
        <TitleTooltip titleLength={0} title={`${keyEvent.name} ${formatDate(keyEvent.date)}`}>
          <Typography variant="caption" component="p" textAlign="center">
            {truncate(keyEvent.name, { length: labelLength })}
          </Typography>
        </TitleTooltip>
      </foreignObject>
    </g>
  );
};

LineChartCustomLabel.propTypes = {
  viewBox: PropTypes.shape({
    x: PropTypes.number,
    y: PropTypes.number,
  }).isRequired,
  keyEvent: PropTypes.shape({
    name: PropTypes.string,
    date: PropTypes.number,
  }),
};
